import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import OverrideIndicator from 'lumen/components/hotel/pricing-assistant/override-indicator';

const HotelPricingAssistantTableOverrideLegend: TOC<object> = <template>
  <div
    class="mb-200 flex items-center justify-end gap-200"
    data-test-id="override-legend"
  >
    <div class="flex items-center gap-50">
      <OverrideIndicator />
      <p class="text-200--regular">
        {{t "pricing_assistant.manual_overrides"}}
      </p>
    </div>
    <div class="flex items-center gap-50">
      <OverrideIndicator @variant="automation-off" />
      <p class="text-200--regular">
        {{t "pricing_manager.automation_off"}}
      </p>
    </div>
  </div>
</template>;

export default HotelPricingAssistantTableOverrideLegend;
